/**
 * Using an accessible dialog or "modal" window. From Reach UI
 * https://ui.reach.tech/dialog
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import MediaQuery from 'react-responsive';
import { BPOINT, breakPoints } from 'constants/breakpoints';
import './dialog-modal.scss';

const mobileOnlyProps = { maxWidth: breakPoints[BPOINT.small].max };
const desktopOnlyProps = { minWidth: breakPoints[BPOINT.medium].min };
const allDeviceProps = { minWidth: breakPoints[BPOINT.small].min };

class DialogModal extends Component {
    static propTypes = {
        children: PropTypes.node,
        onDismiss: PropTypes.func,
        className: PropTypes.string,
        mobile: PropTypes.bool,
        desktop: PropTypes.bool,
        mediaQueryProps: PropTypes.object
    };

    static defaultProps = {
        className: '',
        mobile: false,
        desktop: false
    };

    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        // clearAllBodyScrollLocks();
        document.body.style.overflow = 'visible';
    }

    getDefaultMediaProps() {
        const { mobile, desktop } = this.props;
        if (mobile && desktop) {
            return allDeviceProps;
        }
        if (mobile) {
            return mobileOnlyProps;
        }
        if (desktop) {
            return desktopOnlyProps;
        }
        return allDeviceProps;
    }

    handleMediaQueryChange = visible => {
        if (!visible) {
            document.body.style.overflow = 'visible';
        } else {
            document.body.style.overflow = 'hidden';
        }
    };

    render() {
        const { children, onDismiss, className, mediaQuery } = this.props;

        let mediaQueryProps;
        if (!mediaQuery) {
            mediaQueryProps = this.getDefaultMediaProps();
        } else {
            mediaQueryProps = mediaQuery;
        }

        return (
            <MediaQuery
                {...mediaQueryProps}
                onChange={this.handleMediaQueryChange}>
                <DialogOverlay onDismiss={onDismiss} className="bp">
                    <DialogContent className={className} style={{}}>
                        {children}
                    </DialogContent>
                </DialogOverlay>
            </MediaQuery>
        );
    }
}

export default DialogModal;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/dialog/dialog-modal.jsx